import { HttpMethod, Maybe } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { WORKSPACE_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import { CancelInviteMemberRequest, CancelInviteMemberResponse } from './types';

export function useCancelInviteMember(id: Maybe<string>) {
  const workspaceId = useWorkspace()?.id;

  return useBaseMutation<CancelInviteMemberRequest, CancelInviteMemberResponse>(
    {
      url: `${WORKSPACE_ROOT_ENDPOINT}/${workspaceId}/members/${id}`,
      method: HttpMethod.delete,
    }
  );
}
